// @ts-nocheck
'use strict';
import $ from 'jquery';

import { getRatio } from '../sp/utils/levenshtein.js';
import ProgressBar from 'progressbar.js';
import { Howl } from 'howler';
import { getCookie } from '../base/utils/get_cookie.js';

let correct_icon ="/static/level_test/circle-check.png"
let incorrect_icon ="/static/level_test/circle-xmark.png"
let q_idx = 0;
let isRecognizing = false;
const SpeechRecog =
  // @ts-ignore
  window.SpeechRecognition || window.webkitSpeechRecognition;
const recognition = new SpeechRecog();
recognition.continuous = false;
recognition.lang = 'en-US';
recognition.interimResults = true;
recognition.maxAlternatives = 1;

const beep_sound = $('#beep_sound').get(0);
var lottieRecord = bodymovin.loadAnimation({
  container: document.getElementById('lottie-record'),
  renderer: 'svg', // 렌더링 방식 선택 (canvas, svg 등)
  loop: true,
  autoplay: false,
  path: '/static/lottie/mic.json',
});

const playButton = document.getElementById('play_button');
let picture_pick = 'Look at each picture and choose the best answer. ';
let picture_pick_kor = '(그림을 잘 묘사한 단어나 문장을 고르세요.)';

let yesno = 'Listen and select yes or no. It will be played twice.';

let yesno_kor = '(듣고 Yes나 No를 선택하세요. 두 번 재생됩니다.)';

let choose_robot = 'Listen and choose. It will be played twice.';
let choose_robot_kor = '(듣고 알맞은 로봇을 고르세요.)';

let choose_place = 'Listen and choose. It will be played twice.';
let choose_place_kor = '(듣고 알맞은 장소를 고르세요.)';

let choose_drink = 'Listen and choose. It will be played twice.';
let choose_drink_kor = '(듣고 알맞은 음료를 고르세요.)';

let follow_map = 'Listen and follow. Then circle the place.';
let follow_map_kor = '(듣고 지도를 따라서 도작한 장소에 동그라미 하세요.)';

let best_anwser = 'Read the question and choose the best answer.';
let best_anwser_kor = '(질문에 가장 알맞은 답을 고르세요.)';

let record_this = 'Press the microphone button and read the sentence.';
let record_this_kor = '(마이크 버튼을 누르고 문장을 소리내어 읽어보세요.)';

let fill_blank_1 = 'Read the text and choose the best word for the blank 1.';
let fill_blank_1_kor = '(글을 읽고 빈칸1에 가장 알맞은 단어를 고르세요.)';
let fill_blank_2 = 'Read the text and choose the best word for the blank 2.';
let fill_blank_2_kor = '(글을 읽고 빈칸2에 가장 알맞은 단어를 고르세요.)';
let fill_blank_3 = 'Read the text and choose the best word for the blank 3.';
let fill_blank_3_kor = '(글을 읽고 빈칸3에 가장 알맞은 단어를 고르세요.)';
let fill_blank_4 = 'Read the text and choose the best word for the blank 4.';
let fill_blank_4_kor = '(글을 읽고 빈칸4에 가장 알맞은 단어를 고르세요.)';

let order_words = 'Unscramble the sentence.';
let order_words_kor = '(문장을 올바르게 배열하세요.)';
//ⓐ ⓑ ⓒ Ⓓ

//// const answers = [
//   true, false, true, true,    // 1~4: voca
//   true, true, false, true, false, // 5~9: listening
//   true, false, true, true, true,  // 10~14: speaking
//   false, true, true, false,     // 15~18: reading
//   true, false                  // 19~20: writing
// ];
let q_array = [
  {
    "id":1,'question':picture_pick,'question_kor':picture_pick_kor,
    extra_btn_type: 'none',
    right_answer: 'a',
    q_type:'pick_one',
    content:'ⓐ a red chair<br>ⓑ a red pencil<br>ⓒ a yellow chair',
    answer: '',
  },
  {
    "id":2,'question':picture_pick,'question_kor':picture_pick_kor,
    extra_btn_type: 'none',
    right_answer: 'b',
    q_type:'pick_one',
    content:'ⓐ one egg<br>ⓑ two eggs<br>ⓒ two apples',
    answer: '',
  },
  {
    "id":3,'question':picture_pick,'question_kor':picture_pick_kor,
    extra_btn_type: 'none',
    right_answer: 'a',
    q_type:'pick_one',
    content:'ⓐ This is a mouse.<br>ⓑ This is a rabbit.<br>ⓒ These are mice.',
    answer: '',
  },
  {
    "id":4,'question':picture_pick,'question_kor':picture_pick_kor,
    extra_btn_type: 'none',
    right_answer: 'c',
    q_type:'pick_one',
    content:'ⓐ He is on the farm.<br>ⓑ He is in the zoo.<br>ⓒ He is in the store.',
    answer: '',
  },
  {
    "id":5,'question':yesno,'question_kor':yesno_kor,
    'extra_btn_type':'play',
    'is_played':false,
    'audio_idx':0,
    right_answers: ['NO', 'YES', 'YES', 'NO'], 
    q_type:'pick_four',
    content:'정답:NO, YES, YES, NO',
    answer: '',
  },
  {
    "id":6,'question':choose_robot,'question_kor':choose_robot_kor,
    'extra_btn_type':'play',
    'is_played':false,
    'audio_idx':1,
    
    right_answer: 'b',
    q_type:'pick_one',
    content:'',
    answer: '',
  },
  {
    "id":7,'question':choose_place,'question_kor':choose_place_kor,
    'extra_btn_type':'play',
    'is_played':false,
    'audio_idx':2,
    right_answer: 'b',
    q_type:'pick_one',
    content:'',
    answer: '',
  },
  {
    "id":8,'question':choose_drink,'question_kor':choose_drink_kor,
    'extra_btn_type':'play',
    'is_played':false,
    'audio_idx':3,
    right_answer: 'b',
    q_type:'pick_one',
    content:'',
    answer: '',
  },
  {
    "id":9,'question':follow_map,'question_kor':follow_map_kor,
    'extra_btn_type':'play',
    'is_played':false,
    'audio_idx':4,
    
    right_answer: 'shopping mall',
    q_type:'pick_name',
    content:'',
    answer: '',
  },
  {
    "id":10,'question':best_anwser,'question_kor':best_anwser_kor,
    'extra_btn_type':'none',
    'is_played':false,
    right_answer: 'c',
    q_type:'pick_one',
    content:'Can we play soccer?<br><br>ⓐ No, I can\'t.<br>ⓑ Yes, we do.<br>ⓒ Good idea!',
    answer: '',
  },
  {
    "id":11,'question':best_anwser,'question_kor':best_anwser_kor,
    'extra_btn_type':'none',
    'is_played':false,
    right_answer: 'c',
    q_type:'pick_one',
    content:'What are you good at?<br><br>ⓐ Yes, I am good.<br>ⓑ No, l\'m not good.<br>ⓒ I\'m good at baseball.',
    answer: '',
  },
  {
    "id":12,'question':best_anwser,'question_kor':best_anwser_kor,
    'extra_btn_type':'none',
    'is_played':false,
    right_answer: 'a',
    q_type:'pick_one',
    content:'How much is the juice?<br><br>ⓐ lt\'s one dollar.<br>ⓑ They\'re two dollars.<br>ⓒ lt\'s too expensive.',
    answer: '',
  },
  {
    id: 13,
    question: record_this,
    question_kor: record_this_kor,
    extra_btn_type: 'record',
    is_played: false,
    sentence: 'I can play the violin and she can ride a horse.',
    q_type:'record',
    content:'',
    answer: '',
  },

  {
    id: 14,
    question: record_this,
    question_kor: record_this_kor,
    extra_btn_type: 'record',
    is_played: false,
    sentence: "I like listening to music, but I don't like reading books.",
    q_type:'record',
    content:'',
    answer: '',
  },

  {
    id: 15,
    question: fill_blank_1,
    question_kor: fill_blank_1_kor,
    extra_btn_type: 'none',
    
    right_answer: 'b',
    q_type:'pick_one',
    content:'ⓐ a<br>ⓑ many<br>ⓒ more',
    answer: '',
  },
  {
    id: 16,
    question: fill_blank_2,
    question_kor: fill_blank_2_kor,
    extra_btn_type: 'none',
    right_answer: 'c',
    q_type:'pick_one',
    content:'ⓐ I<br>ⓑ my<br>ⓒ me',
    answer: '',
  },
  {
    id: 17,
    question: fill_blank_3,
    question_kor: fill_blank_3_kor,
    extra_btn_type: 'none',
    right_answer: 'c',
    q_type:'pick_one',
    content:'ⓐ that<br>ⓑ then<br>ⓒ than',
    answer: '',
  },
  {
    id: 18,
    question: fill_blank_4,
    question_kor: fill_blank_4_kor,
    extra_btn_type: 'none',
    right_answer: 'b',
    q_type:'pick_one',
    content:'ⓐ kind<br>ⓑ kinder<br>ⓒ kindest',
    answer: '',
  },

  
  {
    id: 19,
    question: order_words,
    question_kor: order_words_kor,
    extra_btn_type: 'none',
    right_answer: 'Our world is a wonderful place.',
    q_type:'ordering',
    content:'is / world / place / Our / wonderful / a / .',
    answer: '',
  },
  {
    id: 20,
    question: order_words,
    question_kor: order_words_kor,
    extra_btn_type: 'none',
    right_answer: 'The girl is crying because she dropped her ice cream.',
    q_type:'ordering',
    content:'she / because / The girl / ice cream / is crying / dropped / her / .',
    answer: '',
  },
];

const sounds = Array.from(document.querySelectorAll('.audio-src')).map(
  (elem) =>
    new Howl({
      // @ts-ignore
      src: [elem.dataset.src],
      preload: true,
    })
);

function stopAllSounds() {
  sounds.forEach((sound) => sound.stop());
}

function change_question() {
  let q_progress = ((q_idx+1)* 100 / q_array.length) ;
  console.log(q_idx+1,q_progress);
  $('#cur_progress').text(`${q_idx+1}/${q_array.length}`);
  //사운드 끄고, 사운드 있다면 플레이 표시
  stopAllSounds();
  if (q_array[q_idx].is_played) {
    playButton.disabled = true;
  } else {
    playButton.disabled = false;
  }
  $('#play_stop_icon').addClass('fa-play');
  $('#play_stop_icon').removeClass('fa-stop');


  //음성인식 문제일경우 미리 저장된 점수가 있다면 보여줌
  if(q_array[q_idx].extra_btn_type == 'record'){
    if (q_array[q_idx].score) {
      $('#rec_score').show();
      $('#rec_score_num').text(q_array[q_idx].score);
    } else {
      // $('#rec_score').hide();
      $('#rec_score_num').text(0);
    }
  }
  //문제 제시
  let text = `${q_array[q_idx].id}. ${q_array[q_idx].question}`;
  $('.level-question').html(text);
  $('.level-question-kor').html(q_array[q_idx].question_kor);

  //프로그래스
  $('#q_progress').css('width', q_progress + '%');

  //문제 영역
  $('.question_board').each(function () {
    $(this).addClass('hidden');
    if ($(this).attr('data-no') == q_array[q_idx].id) {
      $(this).removeClass('hidden');
    }
  });

  //마이크 등 버튼
  $('.extra_btn').hide();

  if (q_array[q_idx].extra_btn_type == 'play') {
    if (q_array[q_idx].is_played) {
      playButton.disabled = true;
    } else {
      playButton.disabled = false;
    }
    $('#play_footer').show();
  } else if (q_array[q_idx].extra_btn_type == 'record') {
    $('#record_footer').show();
    $('.target_sentence').text(q_array[q_idx].sentence);
  } else {
  }


  //마지막 부분 문제이면 check 해제하기

  

  if (q_idx == q_array.length-1) {
    $('#show_result').show();
    $('#go_next').hide();
  } else if (q_idx == 0) {
    $('#go_prev').hide();
  } else {
    $('#show_result').hide();
    $('#go_next').show();
    $('#go_prev').show();
  }
}

function init() {
  $('.lt_card').removeClass('is_checked');
  $('.lt_card').removeClass('is_clicked');
  $('.level-checkbox-screen').html('');
  $('.ts-type-b').css('margin-top', '15px');
}



function playAudioTwice(audio) {
  let playCount = 0;

  if ($('#play_stop_icon').hasClass('fa-play')) {
    $('#play_stop_icon').addClass('fa-stop');
    $('#play_stop_icon').removeClass('fa-play');
  } else {
    $('#play_stop_icon').addClass('fa-play');
    $('#play_stop_icon').removeClass('fa-stop');
    audio.stop();
    return;
  }


  function onEnd() {
    playButton.disabled = true;
    q_array[q_idx].is_played = true;
  }

  audio.on('end', onEnd);
  audio.play();
}

function setUpUI() {
  $('.float').addClass('hidden');
  $('.start_btn').on('click', function () {
    $('#level-header').addClass('hidden');
    $('#test_area').removeClass('hidden');
    $('#arrow_btns').removeClass('hidden');

    q_idx = 0;
    change_question();
  });

  //옵션 누를때 마크
  $('.radio_option').on('click', function () {
    $(this).siblings('.radio_option').removeClass('is_checked');
    $(this).addClass('is_checked');
    
    // Save the text value of the span element
    const answerText = $(this).find('span.num').text();
    q_array[q_idx].answer = answerText;
  });

  //에스노 버튼 마크
  $('.yn_btn button').on('click', function () {
    // 1) 형제 버튼에서 selected 클래스를 제거하여 회색으로 복귀
    $(this).siblings('button').removeClass('selected');
    // 2) 현재 클릭된 버튼만 selected 클래스를 추가하여 파란색 적용
    $(this).addClass('selected');
  });

  //인식
  $('#lottie-record').on('click', () => {
    if (isRecognizing) {
      recognition.stop();
    } else {
      beep_sound.play();
      setTimeout(() => {
        recognition.start(); //모바일에서는 이상하게 바로 하면 음성인식중에는 비프가 안들리
      }, 500);
    }
  });

  $('#play_button').on('click', function () {
    const audio = sounds[q_array[q_idx].audio_idx];
    playAudioTwice(audio);
  });

  
  $('#show_result').on('click', function () {
    $('.question_board').each(function () {
      $(this).addClass('hidden');
    });
    show_result_area();
  });


  $('#go_next').on('click', function () {
    if (q_idx < q_array.length -1) {
      q_idx++;
      change_question();
    } else {
      
    }
  });
  $('#go_prev').on('click', function () {
    if (q_idx > 0) {
      q_idx--;
      change_question();
    }
  });

  //워드스크램블
  $('.word_checkbox').on('change', function () {
    
    const label = $(this).siblings('label');
    
    let line_id = label.attr('data-line-id');
    let span_id = line_id + '_' + label.attr('data-lid');
    if ($(this).is(':checked')) {
      let text = label.text();
      console.log('Checkbox is unchecked');
      $('#' + line_id).append(
        "<span class='" + span_id + "'>" + text + '</span>'
      );
      label.addClass('is_clicked');
    } else {
      console.log('Checkbox is checked');
      label.removeClass('is_clicked');
      $('.' + span_id).remove();
    }
  });

  window.addEventListener('unload', () => {
    uncheck_scramble_blocks();
  });



  // show_result_area();


  document.getElementById('exportPdfBtn').addEventListener('click', function () {
    
    const questions_element = document.getElementById('questions');
    questions_element.style.display = 'none'; //아예 없애야 프린트에서 안나옴
    const element = document.getElementById('result_area');
  
    const opt = {
      margin:       1,
      filename:     'level_test_score_report.pdf',
      image:        { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        scrollY: 0,
        useCORS: true
      },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak:    { mode: ['avoid-all', 'css', 'legacy'] }
    };
  
    // html2pdf().set(opt).from(element).save();
    setTimeout(() => {
      html2pdf().set(opt).from(element).save().then(() => {
        // element.style.display = 'none';
      });
    }, 100);
  });
  
  
}

// $('#name_input').val('ㄴㄹㄴㅇㄻㄴㅇㄻ')

recognition.addEventListener('start', () => {
  console.log('recognition start');
  isRecognizing = true;
  lottieRecord.play();

  // @ts-ignore
  // $('#rec_score').hide();
  $('#rec_score_num').text(0);
  beep_sound.play();
});
recognition.addEventListener('end', () => {
  console.log('recognition end');
  isRecognizing = false;
  lottieRecord.goToAndStop(0, true);
});

recognition.onnomatch = function () {
  console.log('No match found for speech input');
};

recognition.onsoundstart = function () {
  console.log('Sound detected.');
};

// This event is triggered when an error occurs
recognition.onerror = function (event) {
  console.error('Speech recognition error: ', event.error);
  if (event.error === 'no-speech') {
    console.log('No speech was detected.');
  } else if (event.error === 'audio-capture') {
    console.log(
      'No microphone was found. Ensure that a microphone is available.'
    );
  } else if (event.error === 'not-allowed') {
    console.log('Permission to use the microphone is blocked.');
  } else {
    console.log('other error.,', event.error);
  }
};

recognition.addEventListener('result', (event) => {
  for (let i = event.resultIndex; i < event.results.length; ++i) {
    if (event.results[i].isFinal) {
      let targetText = q_array[q_idx].sentence;
      const { maxRatio, argMax } = getMaxRatioAndArgMax(
        targetText,
        event.results
      );
      let recognizedText = event.results[0][argMax].transcript;
      console.log(maxRatio, argMax);
      let rate = Math.round(100 * maxRatio);
      if (rate > 90) {
        rate = 100;
        recognizedText = targetText;
      }

      $('#rec_score').show();
      $('#rec_score_num').text(rate);
      q_array[q_idx].score = rate;
    }
  }
});

function getMaxRatioAndArgMax(targetText, results) {
  const resultArray = results[0];
  let maximum = -Infinity;
  let argMax = -1;
  for (let i = 0; i < resultArray.length; ++i) {
    console.log(resultArray[i]);
    const ratio = getRatio(targetText, resultArray[i].transcript);
    if (ratio > maximum) {
      maximum = ratio;
      argMax = i;
    }
  }
  return { maxRatio: maximum, argMax: argMax };
}

function make_answer_check() {
  //계산
  let correct_cnt = 0;
  let total_html = '';
  let cnt = 0;
  q_array.forEach((q) => {
    let qst = q.question_kor;
    let content = '';
    let usr_answer = '';
    let rgt_answer = '';
    let icon = '';
    // let right_usr_ = '';

    if(q.q_type == 'ordering'){
      //line19 라는 div의 하위 span들을 순서대로 찾아서 그 텍스트를 연결해 스트링으로 저장
      let user_answer = $('#line'+q.id).children().map(function() {
        return $(this).text();
      }).get().join(' ');

      let correct_answer = q.right_answer;
      if(user_answer.replace(/\s+/g, '') == correct_answer.replace(/\s+/g, '')){
        correct_cnt++;
        q.is_correct = true;
      } else {
        q.is_correct = false;
      }

      
      content=`${q.content}<br>학생의 답: ${user_answer}<br>정답: ${correct_answer}`;

    } else if (q.q_type == 'record') {
      if (q.score >= 60) {
        correct_cnt++;
        q.is_correct = true;
      } else {
        q.is_correct = false;
      }

      content=`${q.sentence}<br>학생의 정확도: ${q.score}%`;
      
    } else if (q.q_type == 'pick_one') {
      if (q.answer == q.right_answer) {
        correct_cnt++;
        q.is_correct = true;
      } else {
        q.is_correct = false;
      }

      content=q.content;
      usr_answer = '학생의 선택:'+ q.answer;
      rgt_answer = '정답:'+ q.right_answer;
    } else if (q.q_type == 'pick_four') {
      //grid-container 라는 div의 하위 모든 button들을 순서대로 찾아서 selected 라는 클래스가 있으면 그 button의 텍스트를 배열에 넣기
      let answer_array = $('#four_answers').find('button.selected').map(function() {
        return $(this).text();
      }).get();
      // answer_array와 q_array[i].right_answers를 비교하여 맞으면 correct_cnt++
      let is_correct = true;
      if (answer_array.length == q.right_answers.length) {
        for (let i = 0; i < answer_array.length; i++) {
          if (answer_array[i] != q.right_answers[i]) {
            is_correct = false;
            break;
          }
        }
      } else{
        is_correct = false;
      }
      
      if (is_correct) {
        correct_cnt++;
        q.is_correct = true;
      }else{
        q.is_correct = false;
      }

      content=`학생의 답:${answer_array.join(', ')}<br>정답:${q.right_answers.join(', ')}`;  

    } else if (q.q_type == 'pick_name') {
      let ua = '';
      let answer_array = $('#map_grid').find('button.is_checked').map(function() {
        console.log($(this).data('name'));
        return $(this).data('name');
      }).get();
      console.log(answer_array);
      if(answer_array.length == 1 && answer_array[0] == q.right_answer){
        correct_cnt++;
        console.log('correct');
        q.is_correct = true;
        q.answer = answer_array[0];
      } else{
        q.is_correct = false;
        q.answer = answer_array[0];
      }

      content=`학생의 답:${q.answer}<br>정답:${q.right_answer}`;  
    } 


    //답안 만들기
  icon= q.is_correct ? correct_icon : incorrect_icon;
  // console.log(q.id);
  // console.log(q.question_kor);
  // console.log(content);
  // console.log(usr_answer);
  // console.log(rgt_answer);
  // console.log(icon);
  let result_html = `
                  <tr class='no-break'>  
                    <td class="result_q_num">${q.id}</td>
                    <td  class='text_left td_right_dash'>
                      <div class="ask_this">${q.question}<br>${q.question_kor}</div> 
                      <div class="cell s has-audio">${content}
                      </div>
                    </td>
                    <td class='text_left'>
                      <div id="user_answer1" class="cell c">${usr_answer}</div>
                      <div class="cell r">${rgt_answer}</div>
                    </td>
                    <td>
                      <div class="cell c">
                        <img id="res_icon1" src="${icon}" alt="">
                      </div>
                    </td>
                  </tr>`;
    total_html += result_html;
    if(cnt == 1 || cnt == 9|| cnt == 14){ {
          result_html = `
                      <tr class="page-break-tr">
                        <td colspan="4">
                          <div class="page-break"></div>
                        </td>
                      </tr>`; 
          total_html += result_html;

        }
      }
      cnt++;
  });

  //총점
  let score = Math.round((correct_cnt / q_array.length) * 100);
  console.log(score);
  $("#your_score").text(score); 
  $("#sheet_body").html(total_html); 

}

// const answers = [
//   true, false, true, true,    // 1~4: voca
//   true, true, false, true, false, // 5~9: listening
//   true, false, true, true, true,  // 10~14: speaking
//   false, true, true, false,     // 15~18: reading
//   true, false                  // 19~20: writing
// ];

/**
     * 각 영역별 점수를 계산하는 함수
     * @param {Array} answers - 20문제 결과 배열
     * @returns {Object} 영역별 점수
     */
function calculateScores() {
  const scores = {
    voca: 0,
    listening: 0,
    speaking: 0,
    reading: 0,
    writing: 0
  };

  // 1~4번: voca (인덱스 0~3)
  for (let i = 0; i < 4; i++) {
    scores.voca += q_array[i].is_correct ? 1 : 0;
  }
  // 5~9번: listening (인덱스 4~8)
  for (let i = 4; i < 9; i++) {
    scores.listening += q_array[i].is_correct ? 1 : 0;
  }
  // 10~14번: speaking (인덱스 9~13)
  for (let i = 9; i < 14; i++) {
    scores.speaking += q_array[i].is_correct ? 1 : 0;
  }
  // 15~18번: reading (인덱스 14~17)
  for (let i = 14; i < 18; i++) {
    scores.reading += q_array[i].is_correct ? 1 : 0;
  }
  // 19~20번: writing (인덱스 18~19)
  for (let i = 18; i < 20; i++) {
    scores.writing += q_array[i].is_correct ? 1 : 0;
  }

  return scores;
}

/**
 * 각 영역의 점수를 백분율로 계산하는 함수
 * @param {Object} scores - 영역별 점수
 * @returns {Object} 영역별 백분율 점수
 */
function calculatePercentages(scores) {
  return {
    voca: (scores.voca / 4) * 100,
    listening: (scores.listening / 5) * 100,
    speaking: (scores.speaking / 5) * 100,
    reading: (scores.reading / 4) * 100,
    writing: (scores.writing / 2) * 100
  };
}

/**
 * Chart.js를 이용하여 스파이더 차트를 렌더링하는 함수
 * @param {Object} percentages - 영역별 백분율 점수
 */
function renderSpiderChart(percentages) {
  const ctx = document.getElementById('spiderChart').getContext('2d');
  const data = {
    labels: ['Voca', 'Listening', 'Speaking', 'Reading', 'Writing'],
    datasets: [{
      label: 'Score Percentage',
      data: [
        percentages.voca,
        percentages.listening,
        percentages.speaking,
        percentages.reading,
        percentages.writing
      ],
      backgroundColor: 'rgba(88, 176, 223, 0.2)',
      borderColor: 'rgba(88, 176, 223, 1)',
      borderWidth: 2,
      pointBackgroundColor: 'rgba(88, 176, 223, 1)'
    }]
  };

  const config = {
    type: 'radar',
    data: data,
    options: {
      scales: {
        r: {
          suggestedMin: 0,
          suggestedMax: 100,
          ticks: {
            stepSize: 20
          }
        }
      }
    }
  };

  new Chart(ctx, config);
}


function updateScoreTable(scores) {
  // 각 영역의 최대 점수
  const maxScores = {
    voca: 4,
    listening: 5,
    speaking: 5,
    reading: 4,
    writing: 2
  };

  // 총점 계산
  const totalScore = scores.voca + scores.listening + scores.speaking + scores.reading + scores.writing;
  const maxTotal = maxScores.voca + maxScores.listening + maxScores.speaking + maxScores.reading + maxScores.writing;

  // score-table의 tbody 첫번째 tr 요소 선택
  const scoreRow = document.querySelector('.score-table tbody tr');
  if (!scoreRow) return;

  // 셀 내용 업데이트: 각 영역별 점수와 총점을 "획득점수/최대점수" 형태로 표시
  scoreRow.cells[0].textContent = `${scores.voca}/${maxScores.voca}`;
  scoreRow.cells[1].textContent = `${scores.listening}/${maxScores.listening}`;
  scoreRow.cells[2].textContent = `${scores.speaking}/${maxScores.speaking}`;
  scoreRow.cells[3].textContent = `${scores.reading}/${maxScores.reading}`;
  scoreRow.cells[4].textContent = `${scores.writing}/${maxScores.writing}`;
  scoreRow.cells[5].textContent = `${totalScore}/${maxTotal}`;

  return totalScore; // 총점 반환
}


// 점수 범위에 따른 레벨표 (예시 데이터)
const levelTable = [
  {
    min: 0,
    max: 2,
    level: "Beginner 1",
    book: "ABC Talk! Talk! / I’m Phonics Star! / JELLY Phonics / I’m Story Star! STEP 1",
    cefr: "Pre A1 (Starters)",
    jet: "JET-kids 3,4급"
  },
  {
    min: 3,
    max: 4,
    level: "Beginner 2",
    book: "Phonics Talk! Talk! / SuperSafari 1-1, 1-2 / l'm Story Star! STEP 2",
    cefr: "Pre A1 (Starters)",
    jet: "JET-kids 1,2급"
  },
  {
    min: 5,
    max: 6,
    level: "Basic 1",
    book: "New Elementary EngIish 3rd / [New] Guess What 1-1 / Super Safari 2-1, 2-2 / l'm Story Star! STEP 3 Book 1-4",
    cefr: "Pre A1 (Starters)",
    jet: "JET 6급"
  },
  {
    min: 7,
    max: 8,
    level: "Basic 1",
    book: "[New] Guess What 1-2 / Super Safari 3-1, 3-2 / l'm Story Star! STEP 3 Book 5-8",
    cefr: "Pre A1 (Starters)",
    jet: "JET 6급"
  },
  {
    min: 9,
    max: 10,
    level: "Basic 2",
    book: "New Elementary English 4th / [New] Guess What 2-1 / Let's Talk 1-1A, 1-1B / Story Garden Basic Book 1-4",
    cefr: "Pre A1 (Starters)",
    jet: "JET 5급"
  },
  {
    min: 11,
    max: 12,
    level: "Basic 2",
    book: "[New] Guess What 2-2 / Let's Talk 1-2A, 1-2B / Story Garden Basic Book 5-8",
    cefr: "Pre A1 (Starters)",
    jet: "JET 5급"
  },
  {
    min: 13,
    max: 14,
    level: "Intermediate 1",
    book: "New Elementary English 4th / [New] Guess What 3-1, 3-2 / Let's Talk 2-1A, 2-1B / Story Garden lnter Book 1-4",
    cefr: "Pre A1 (Starters)",
    jet: "JET 4급"
  },
  {
    min: 15,
    max: 16,
    level: "Intermediate 1",
    book: "[New] Guess What 4-1 , 4-2 / Let's Talk 2-2A, 2-2B / Story Garden lnter Book 5-8 ",
    cefr: "A1(Movers)",
    jet: "JET 4급"
  },
  {
    min: 17,
    max: 18,
    level: "Intermediate 2",
    book: "[New] Guess What 5-1 / Let's Talk 3-1, 3-2 / Reading & Discussion Book 1-4",
    cefr: "A1(Movers)",
    jet: "JET 3급"
  },
  {
    min: 19,
    max: 20,
    level: "Intermediate 2",
    book: "[New] Guess What 5-2 / Let's Talk 4-1, 4-2 / Reading & Discussion Book 5-8",
    cefr: "A1(Movers)",
    jet: "JET 3급"
  }
];


/**
 * 주어진 점수를 바탕으로 levelTable에서 해당 레벨 정보를 찾는 함수
 * @param {number} score - 학습자의 점수 (0 ~ 20)
 * @returns {object|null} - 해당 점수 범위의 레벨 정보 객체 (못 찾으면 null)
 */
function getLevelInfo(score) {
  for (let i = 0; i < levelTable.length; i++) {
    const range = levelTable[i];
    if (score >= range.min && score <= range.max) {
      return range;
    }
  }
  return null; // 범위에 해당 없으면 null 반환
}


function showLevelInfo(totalScore) {
  const userScore = totalScore;

    const levelInfo = getLevelInfo(userScore);

    if (levelInfo) {
      document.getElementById('displayLevel').textContent = levelInfo.level;
      document.getElementById('displayBook').textContent = levelInfo.book;
      document.getElementById('displayCEFR').textContent = levelInfo.cefr;
      document.getElementById('displayJET').textContent = levelInfo.jet;
    } else {
      // 범위 밖 점수일 경우 처리
      document.getElementById('displayLevel').textContent = "해당 없음";
      document.getElementById('displayBook').textContent = "-";
      document.getElementById('displayCEFR').textContent = "-";
      document.getElementById('displayJET').textContent = "-";
    }
}


const reviewComments = {
  perfect: `Perfect Score<br>
Wow! Great effort and an amazing score! Keep up the amazing work and keep learning. You’re doing awesome! <br>
(우와! 멋진 노력과 훌륭한 점수예요! 대단해요! 계속 이렇게 열심히 하고 즐겁게 배우세요. 정말 잘하고 있어요!)
`,

  improveVoca: `Needs to Improve Vocabulary (개선 영역: 어휘)<br>
You’re doing great! Now, let’s focus on learning more words. The more words you know, the easier it will be to express yourself. Keep going, and you’ll get better every day!<br>
(정말 잘했어요! 이제 더 많은 단어를 배우는 데 집중해 봐요! 더 많은 단어를 알수록 자신을 더 쉽게 표현할 수 있어요. 계속해서 노력하면 매일 더 나아질 거예요!)
`,

  improveListening: `Needs to Improve Listening  (개선 영역: 듣기)<br>
You’re doing excellent! Keep listening to English songs, stories, or cartoons, and your listening skills will improve a lot. Don’t give up. You’re improving every day!<br>
(정말 잘 하고 있어요! 그리고 영어 노래, 이야기, 만화를 계속 듣다 보면 , 듣기 실력도 훨씬 좋아질 거예요. 포기하지 마세요. 매일 조금씩 발전하고 있어요!)
`,

  improveSpeaking: `Needs to Improve Speaking (개선 영역: 말하기)<br>
You’re doing great! But speaking takes practice, so don’t be shy! Try talking with friends, reading out loud, or practicing in front of a mirror. Keep going and you’ll get better! <br>
(멋지게 해냈어요! 그런데 말하기는 연습이 중요하니까 부끄러워하지 마세요! 친구들과 이야기해 보거나, 소리 내어 읽거나, 거울 앞에서 연습해 보세요. 계속하면 점점 더 나아질 거예요!)
`,

  improveReadingWriting: `Needs to Improve Reading  & Writing (개선 영역: 읽기와 쓰기)<br>
You’re on the right track! Reading fun stories and writing short sentences will help you improve. Every great reader and writer started just like you! You can do it!<br>
(잘하고 있어요! 재미있는 이야기를 읽고 짧은 문장을 써보면 실력이 더 좋아질 거예요. 모든 훌륭한  독자와 작가도 이렇게 시작했답니다! 잘 할 수 있어요!)
`,

  improveOverall: `Needs to Improve Every Area (개선 영역: 모든 영역)<br>
Great start! Keep working on all areas of English. Don’t worry. Every day you practice, you’ll get better and better!<br>
(좋은 시작이에요! 영어의 모든 영역을 계속해서 연습해 보세요. 걱정하지 마세요. 매일 조금씩 연습하면 점점 더 나아질 거예요!)
`
};


/**
 * 리뷰 코멘트를 선택해 반환하는 함수
 * @param {number} totalScore - 총점 (0~20)
 * @param {object} percentages - 영역별 백분율. 예: { voca: 75, listening: 60, speaking: 80, reading: 50, writing: 100 }
 * @returns {string} 선택된 리뷰 코멘트
 */
function displayReviewComment(totalScore, percentages) {
  let comment = '';
  // 1) 총점이 19 또는 20 → #1 (Perfect Score)
  if (totalScore >= 19) {
    comment= reviewComments.perfect;
  } else if (totalScore <= 5) {// 2) 총점이 0 ~ 5 → #6 (Needs to Improve Overall)
    comment= reviewComments.improveOverall;
  } else {

    // 3) 그 외 → 가장 낮은 영역 확인 (단, reading과 writing은 합쳐서 계산)
    //    예) (reading% + writing%) / 2 로 평균 구하기
    const readingWritingPercent = (percentages.reading + percentages.writing) / 2;

    // 비교를 위해 각 영역을 key: value 형태로 정리
    const areaScores = {
      voca: percentages.voca,
      listening: percentages.listening,
      speaking: percentages.speaking,
      readingWriting: readingWritingPercent
    };

    // 가장 낮은 값 찾기
    let lowestArea = null;
    let lowestValue = 101; // 0~100 범위를 가정하므로 101로 초기화

    for (const area in areaScores) {
      console.log(area, areaScores[area]);
      if (areaScores[area] < lowestValue) {
        lowestValue = areaScores[area];
        lowestArea = area;
      }
    }
    
    // lowestArea 값에 따라 코멘트 선택
    
    switch (lowestArea) {
      case 'voca':
        comment= reviewComments.improveVoca;
        break;
      case 'listening':
        comment= reviewComments.improveListening;
        break;
      case 'speaking':
        comment= reviewComments.improveSpeaking;
        break;
      case 'readingWriting':
        comment= reviewComments.improveReadingWriting;
        break;

    } 
  }

  $("#final_review").html(comment); // 기본 코멘트
}

function uncheck_scramble_blocks() {
  // word_checkbox 클래스를 가진 모든 input 요소 선택
  const checkboxes = document.querySelectorAll('input.word_checkbox');

  // 각각의 체크박스를 체크 해제
  checkboxes.forEach(checkbox => {
    checkbox.checked = false;
  });

}


function show_result_area() {
  
  $('#name_field').text($('#name_input').val());
  $('#grade_field').text($('#grade_input').val());

  $('#questions').addClass('hidden');
  $('.result_view').removeClass('hidden');
  $('#result_paper').removeClass('hidden');

  uncheck_scramble_blocks();//나갔다 다시 오면 체크 상태로 남아 있는 오류 수정위해
  make_answer_check();

  const scores = calculateScores();
  const totalScore = updateScoreTable(scores);
  const percentages = calculatePercentages(scores);
  renderSpiderChart(percentages);
  
  showLevelInfo(totalScore) ;
  console.log(totalScore, percentages);  
  displayReviewComment(totalScore, percentages);

}

setUpUI();
